<template>
  <div class="game-end-backdrop">
    <transition name="fade-up">
      <div
        v-if="displayWinnerMessage"
        class="game-end-container"
      >
        <span class="game-end-message">
          {{ winnerMessage }}
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'GameEndView',
  props: {
    gameState: Object
  },
  data: () => ({
    displayWinnerMessage: false
  }),
  computed: {
    winnerMessage: function () {
      if ('scoreboard' in this.gameState) {
        const winners = this.gameState.scoreboard.filter(entry => entry.score === this.gameState.scoreboard[0].score).map(entry => entry.username);

        if (winners.length === 1) {
          return `${ winners[0] } wins!`
        } else {
          return `It's a tie between ${ winners.slice(0, -1).join(', ') } and ${ winners.slice(-1)[0] }!`
        }
      }

      return '';
    }
  },
  mounted: function () {
    this.displayWinnerMessage = true;
    setTimeout(() => {
      this.displayWinnerMessage = false;
    }, 4000);
  }
})
</script>

<style scoped lang="scss">
.game-end-backdrop {
  display: flex;
  align-items: center;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.game-end-container {
  flex: 1;
  border: 0.1em solid $brand-teal;
  border-radius: 0.4em;
  background-color: $natural-white;
  box-shadow: 0 6px 8px -4px $smoke-gray;
  padding: 1em 0;
}

.game-end-message {
  font-size: 2em;
}
</style>
